import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Map, Users, Target, Calendar, Building2, BarChart3, Clock, FileText, DollarSign, ClipboardCheck } from 'lucide-react';
import './FieldTeam.css';

const navItems = [
  { path: '/field-team/live-map', icon: Map, label: 'Live Map' },
  { path: '/field-team/timeline', icon: Clock, label: 'Timeline' },
  { path: '/field-team/team', icon: Users, label: 'Team' },
  { path: '/field-team/targets', icon: Target, label: 'Targets' },
  { path: '/field-team/meetings', icon: Calendar, label: 'Meetings' },
  { path: '/field-team/clients', icon: Building2, label: 'Clients' },
  { path: '/field-team/invoices', icon: FileText, label: 'Invoices' },
  { path: '/field-team/commission', icon: DollarSign, label: 'Commission' },
  { path: '/field-team/clearance', icon: ClipboardCheck, label: 'Clearance' },
  { path: '/field-team/reports', icon: BarChart3, label: 'Reports' },
];

function FieldTeamLayout({ children }) {
  const location = useLocation();

  return (
    <div className="field-team-container">
      {/* Top Navigation Bar */}
      <div className="field-team-topbar">
        <div className="field-team-topbar-left">
          <h1 className="field-team-title">Field Team</h1>
        </div>
        <nav className="field-team-nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `field-team-nav-item ${isActive ? 'active' : ''}`
              }
            >
              <item.icon size={16} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className="field-team-content">
        {children}
      </div>
    </div>
  );
}

export default FieldTeamLayout;
